import request from '../request'

export default {
  personStat(parameter) {
    return request({
      url: 'dashboard/person-stat',
      method: 'post',
      data: parameter,
    })
  },
  userType(parameter) {
    return request({
      url: 'dashboard/user-type-list',
      method: 'post',
      data: parameter,
    })
  },
  orderType(parameter) {
    return request({
      url: 'dashboard/order-type-list',
      method: 'post',
      data: parameter,
    })
  },
  specList(parameter) {
    return request({
      url: 'dashboard/spec-list',
      method: 'post',
      data: parameter,
    })
  },
  openCloseList(parameter) {
    return request({
      url: 'dashboard/open-close-list',
      method: 'post',
      data: parameter,
    })
  },
  stadiumList(parameter) {
    return request({
      url: 'dashboard/stadium-list',
      method: 'post',
      data: parameter,
    })
  },
  sevenDayOrderList(parameter) {
    return request({
      url: 'dashboard/seven-day-order-list',
      method: 'post',
      data: parameter,
    })
  },
  sevenDaySpecOrder(parameter) {
    return request({
      url: 'dashboard/seven-day-spec-order-list',
      method: 'post',
      data: parameter,
    })
  },
  sevenDayStadiumList(parameter) {
    return request({
      url: 'dashboard/seven-day-stadium-order-list',
      method: 'post',
      data: parameter,
    })
  },
}